import { createSlice } from '@reduxjs/toolkit'

export const dashboardSlice = createSlice({
  name: 'favorites',
  initialState: {
    history: [],
    visibleCardItems: 3,
  },
  reducers: {
    setHistory(state, action) {
      state.history = action.payload
    },
    setVisibleCardItems(state, action) {
      state.visibleCardItems = action.payload
    },
    deleteAllHistory(state) {
      state.history = []
    },
    deleteHistoryItem(state, action) {
      state.history = state.history.filter((el) => el.id !== action.payload)
    },
  },
})

export const dashboardActions = dashboardSlice.actions

export default dashboardSlice.reducer
